import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(state: RootState['smartLinks'] = {}, action: Action) {
  switch (action.type) {
    case 'ADD_SMART_LINK': {
      return action.payload
    }
    default:
      return state
  }
}
